import { Controller } from "@hotwired/stimulus"

import Swal from 'sweetalert2';

export default class extends Controller {
  static values = {
    motivoCorrecao: String,
  }

  connect() {
  }

  async marcarConferido (event) {
    const form = document.getElementById('form-relatorio')
    if(!form.reportValidity()) {
      return;
    }

    event.preventDefault()
    event.stopImmediatePropagation()

    const result = await Swal.fire({
      title: 'Atenção!',
      text: 'Tem certeza de que deseja marcar este relatório como conferido e enviá-lo para a Diretoria de Gestão de Pessoas? \n\n Esta ação não poderá ser desfeita.',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Não',
      confirmButtonText: 'Sim',
      allowOutsideClick: false,
    });

    if(result.isConfirmed) {
      form.submit();
    }
  }

  async solicitarCorrecaoServidor(event) {
    event.preventDefault()
    event.stopImmediatePropagation()

    const form = document.getElementById('form-relatorio')

    const motivoCorrecao = document.getElementById('relatorio_motivo_correcao');

    const result = await Swal.fire({
      title: 'Solicitar correção',
      input: 'textarea',
      inputLabel: "Informe o motivo abaixo",
      inputPlaceholder: "Digite o motivo aqui...",
      inputAttributes: {
        "aria-label": "Digite o motivo aqui...",
      },
      inputValue: motivoCorrecao?.value,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Salvar',
      backdrop: true,
      focusCancel: true,
      allowOutsideClick: false,
      inputValidator(value) {
        if(!value || value.trim().length == 0) {
          return 'Motivo da correção não pode ficar em branco'
        }
      }
    });

    if(result.isConfirmed && result.value) {
      motivoCorrecao.value = result.value;
      const hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = 'solicitar_correcao';
      hiddenInput.value = 'true';
      form.appendChild(hiddenInput);

      form.submit();
    }
  }
}
